import { render, staticRenderFns } from "./UploadCardImage.vue?vue&type=template&id=6ee9ff52&scoped=true&"
import script from "./UploadCardImage.vue?vue&type=script&lang=js&"
export * from "./UploadCardImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadCardImage.vue?vue&type=style&index=0&id=6ee9ff52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee9ff52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
